import React from 'react';
import cx from 'classnames';

import Button from '../../../Button/components/Button';
import './_list-action-button.scss';






const ListActionButton = (props) => {
  const { text, isMobile } = props;

  const buttonProps = {
    ...props,
    text: undefined,
    isMobile: undefined,
    isFullWidth: isMobile
  };

  return (
    <div className={
    cx('list-action-button',
    { 'list-action-button--small-screen': isMobile })}>

      <Button
        {...buttonProps}>

        {text}
      </Button>
    </div>);

};

export default ListActionButton;